'use strict';

$(function () {
  $('body')

    .on("click", '.hamburger', function () {
      $('body').toggleClass('menu-open');
    })

    .on('click', '.close_menu', function () {
      $('body').removeClass('menu-open');
    })

    .on('click', '[data-modal]', function () {
      $('#modal-pjax').load($(this).data('modal'), function () {
        $('#modal-pjax').focus();
      });
      $('body').removeClass('menu-open').addClass('modal-open');
      return false;
    })

    .on('submit', 'form', function (event) {
      $(this).find('[type=submit]').attr('disabled', true).text('').addClass('spinner');
    })

    .on('click', '.close, #overlay', function () {
      $('body').removeClass('modal-open').removeClass('menu-open');
      $('#modal-pjax > *').remove();
      // mahist = document.getElementById('profile');
      // if(mahist) { $.pjax.reload({container: '#profile', async: false}); }
    })
    .on('click', '.ico-eye-close, .ico-eye-open', function () {
      $('.ico-eye-close, .ico-eye-open').toggleClass('ico-eye-open', 'ico-eye-close');
      $('input[placeholder^="****"]').attr('type', function (index, attr) { // prev('input')
        return attr === 'text' ? 'password' : 'text';
      });
    })

    .on('click', '.to_top', function() {
      //  onclick="window.scrollTo(0, 0)"
      $("html, body").animate({ scrollTop: 0 }, "slow");
      return false;
    })

    .on('change', '#registermeform-file', function () {
      var reader = new FileReader();
      reader.onload = function (e) {
        $('#cropped-result').html('<div id="image-cropper"><div class="close"></div></div>');
        $('#avatar_field').hide();
        $('#image-cropper').croppie({
          viewport: {
            width: 280,
            height: 280,
            type: 'circle'
          },
          boundary: {
            width: 320,
            height: 280
          },
          enableOrientation: true
        });
        $('#image-cropper').croppie('bind', {
          url: event.target.result
        });
      };
      reader.readAsDataURL(this.files[0]);
    })

    .on('click', '#image-cropper .close', function () {
      $('#image-cropper').croppie('destroy');
      $(this).remove();
      $('#avatar_field').show();
    })

    .on('click', '#register-form button.btn_submit', function () {
      $('#image-cropper').croppie('result', {
        type: 'base64',
        format: 'png',
        size: { width: 560, height: 560 }
      }).then(function (base64Data) {
        $('#registermeform-avatar').val(base64Data);
        $('#registermeform-file').val('');
        console.log(base64Data);
      });
    })

    .on('click', '.porque', function() {
      let bubble = $(this).next('.bubble');
      if($(bubble).is(":visible")) {
        $(this).next('.bubble').hide();
      } else {
        $(this).next('.bubble').show();
      }
    })

    .on('click', '.bubble', function() {
      $(this).hide();
    })

    .on('click', '.open_player', function() {
      $('body').addClass('modal');
      let id = $(this).data('video');
      if(id) {
        $("#modal").html(
          '<video oncontextmenu="return false;" controlsList="nodownload" controls preload="metadata" autoplay><source src="/video/' +
            id +
            '.mp4?v=2" type="video/mp4" /></video><button class="close">закрити</button>'
        );
        var hideStr = 'Hide', showStr = 'Show', hideClass = 'hide';
        $('video + button.close').click(function(){
          var button = $(this);
          var video = button.parent().find('video');
          video.trigger('pause');
          // video.prop('muted');
          $('body').removeClass('modal');
        });
      } else {
        $('#modal').html('<div class="modal_content"><p>Наразі відео не доступне</p></div>');
      }

    })

    .on('click', '#overlay', function() {
      $('body').removeClass('modal');
    });
});
